import { render, staticRenderFns } from "./ProfileStatusItem.vue?vue&type=template&id=6d17dbc3&"
import script from "./ProfileStatusItem.vue?vue&type=script&lang=ts&"
export * from "./ProfileStatusItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports